import { get, postJSON, del, post } from '../utils/axios'
import config from '../utils/config'

// 会员卡卡种列表
interface GetVersionListOptions {

}
export const getVersionList = (options?: GetVersionListOptions) => get('/yme-system/setting/versionUpdateRecords')

// 必填字段列表查询
interface fieldRequiredCfgSelectListProps {
    busType:string //业务类型 0-客户 1-车辆 2-接车
}
export const fieldRequiredCfgSelectList = (options?: fieldRequiredCfgSelectListProps) => get('fieldRequiredCfg/selectList',options)

interface ItemData {
    pk:string
    feedbackPk:string// 反馈主表pk
    type:string //类型0-图片 1-视频
    url:string //图片地址
}

// 问题反馈提交
interface feedbackSubmitFeedbackProps {
    type: string //类型 0-功能异常 1-意见与建议 2-其他
    remark: string //描述
    contactInformation: string //联系方式或邮箱
    imgList:ItemData[]
}
export const feedbackSubmitFeedback = (options?: feedbackSubmitFeedbackProps) => postJSON('/yme-system/feedback/submitFeedback',options)

// 我的历史反馈记录
interface feedbackSelectListProps {
    page: number
    size: number 
}
export const feedbackSelectList = (options?: feedbackSelectListProps) => get('/yme-system/feedback/selectList',options)

// 查询当前登录用户权限集合
export const getSelectUserRoleMenus = () => get('/yme-system/menu/selectUserRoleMenus', {}, {}, false)

// 账号密码登录 只是在本地开发环境需要用到
export const loginByPassword = () => post('/yme-auth/sysLogin/loginByPassword', {
    username: "13434450121",
	password: "654321",
	grant_type: "password",
	verificationCode: ""
})

// 腾讯地图获取经纬度
export const getLocation = (url) => {
    return new Promise((resolve, reject) => {
        try {
            window.getLocation = response => {
                if( response.status === 0 ) {
                    resolve(response)
                }else {
                    reject()
                }
            };
            var jsonp=document.createElement('script')
            jsonp.type = 'text/javascript'
            jsonp.src= url + `${url.includes('?') ? '&' : '?'}key=${config.mapKey}&output=jsonp&callback=window.getLocation`
            document.getElementsByTagName('head')[0].appendChild(jsonp);
        } catch (error) {
            reject()
        }
    })
}

// 腾讯地图获取详细地址
export const getAddress = (url:string, location:string) => {
    return new Promise((resolve, reject) => {
        try {
            window.getAddress = response => {
                if( response.status === 0 ) {
                    resolve(response)
                }else {
                    reject({
                        status:1
                    })
                }
            };
            var jsonp=document.createElement('script')
            jsonp.type = 'text/javascript'
            jsonp.src= url + `${url.includes('?') ? '&' : '?'}location=${location}&key=${config.mapKey}&output=jsonp&callback=window.getAddress`
            document.getElementsByTagName('head')[0].appendChild(jsonp);
        } catch (error) {
            reject({
                status:1
            })
        }
    })
}

// 生成小程序码
interface createMiniQrCodeProps {
    pageUrl?: string //小程序页面URL
    params?: string //参数
}
export const getCreateMiniQrCode = (options?: createMiniQrCodeProps) => post('common/createMiniQrCode', options)

// 获取登录用户信息
export const getCurrentUserInfo = () => get('/yme-system/setting/getCurrentUserInfo')

// 发送验证码
export const sendPhoneCode = (phone: string) => post('common/sendPhoneCode', { phone })

// 校验验证码
export const verificationCode = (phone: string, verificationCode: string) => post('common/checkVerification', { phone, verificationCode })

// 门店或服务商费用方案详情
export const getMerchantRateCfg = (orgPk: string) => post('/payApi/payAccountRateCfg/merchantRateCfg', { orgPk })

//个人账户费率方案详情
export const getPersonalRateCfg = () => post('/payApi/payAccountRateCfg/personalRateCfg')

//门店展示信息
export const selectOrgInfo = (orgPk) => get(`/yme-system/org/selectOrgInfo`,{ orgPk })

//获取用户当前最新信息
export const getLoginInfo = (pUserPk) => get(`/yme-auth/oauth/getLoginInfo`,{ pUserPk }, {}, false)

//商户端获取待审核的单据PK
interface getApprovalAuditInfoProps {
    pk: string //单据PK
    moduleType: string | number //所属哪个模块 0-销售订单 1-销售出库单 2-销售开单 3-销售发货单 4-销售开票单 5-采购订单 6-采购入库 7-采购开单 8-应付款单 9-应收款单 10-核销款单 11-其它支出单 12-其它收入单 13-资金调拨单
}
export const getApprovalAuditInfo = (options:getApprovalAuditInfoProps) => postJSON(`/yme-agency/approval/getApprovalAuditInfo`,{ ...options }, {}, false)


//门店类型列表
export const getOrgTypeList = () => get(`/yme-system/orgType/getOrgTypeList`)

//组织版本列表
export const getOrgVersionList = (enable: string | number) => postJSON(`/yme-system/orgVersion/getOrgVersionList`, {
    enable,
    page: 1,
    size: 999
})

// 查询全部行业
export const getIndustryAll = () => get(`/yme-system/org/getIndustryAll`)


// 申请开通门店/商户
export const addOrg = (options) => postJSON(`/yme-system/org/h5/addOrg`, {
    ...options
})


// 运营战报详情
export const getOperationReportVO = (orgPk: any, date?: any) => postJSON(`operationReport/getOperationReportVO`, {
    orgPk,
    date
})


// 天气查询(未来5天)
export const weather = (orgPk: any) => post(`common/weather`, {
    orgPk
})



// 小程序扫码登录二维码(无回调)
export const miniLoginQrCode = (loginPk: any) => post(`/yme-gewe/login/miniLoginQrCode`, {
    loginPk
})
